export const VIEWMODES = {
  carousel: 'carousel',
  grid: 'grid'
};
//# sourceMappingURL=constants.js.map